module.exports = __webpack_public_path__ + "img/support1.5744cc61.jpg";